// extracted by mini-css-extract-plugin
export default {"wrapper":"popularProducts_wrapper__7Z9oQ","products":"popularProducts_products__PhlNu","viewMore":"popularProducts_viewMore__3Cr03"};